import { render, staticRenderFns } from "./ConnectedProject.vue?vue&type=template&id=1d3ddfed&scoped=true&"
import script from "./ConnectedProject.vue?vue&type=script&lang=js&"
export * from "./ConnectedProject.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedProject.vue?vue&type=style&index=0&id=1d3ddfed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ddfed",
  null
  
)

export default component.exports